@let menuItem = item();
@if (menuItem.icon) {
    <span class="material-symbols-outlined">{{ menuItem.icon }}</span>
}
@if (menuItem.label) {
    <span class="initials">{{ menuItem.label }}</span>
}
<span>{{ menuItem.title }}</span>
